import React from "react";
import { cn } from "../ui";
import { t } from "../../i18n";

interface StepsBarProps {
  step: 1 | 2;
  label: string;
  tone?: "primary" | "whatsapp";
}

/** "Passo N de 2 · rótulo" com as barrinhas de progresso dos modais em 2 passos. */
export const StepsBar: React.FC<StepsBarProps> = ({ step, label, tone = "primary" }) => {
  const on = tone === "whatsapp" ? "bg-whatsapp" : "bg-primary";
  return (
    <span className="mt-1 flex items-center gap-1.5 text-caption text-fg-muted">
      <i className={cn("h-1 w-4 rounded-full", on)} aria-hidden />
      <i className={cn("h-1 w-4 rounded-full", step > 1 ? on : "bg-line")} aria-hidden />
      {t("common.step", { step, label })}
    </span>
  );
};
